import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconBeaker = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--beaker")} iconColor={color} size={size} width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <defs>
          <path d="m23.497 19.827-8-10.994V1.751h1.748V0H6.755v1.75h1.749v7.083l-8 10.994A2.629 2.629 0 0 0 2.621 24h18.756a2.624 2.624 0 0 0 2.119-4.173zM10.252 9.404V1.75h3.496v7.653l1.704 2.34H8.546l1.706-2.34zM22.157 21.77a.858.858 0 0 1-.78.478H2.623a.875.875 0 0 1-.706-1.39l5.358-7.364h9.452l5.358 7.363c.197.266.225.62.073.913z" id="icon--centivo--beaker"/>
      </defs>
      <g fill="none" fillRule="evenodd">
          <use fill="currentColor" xlinkHref="#icon--centivo--beaker"/>
      </g>
  </IconWrapper>
)
